module.exports = __webpack_public_path__ + "static/ketomau.2f6c073a.png";


//////////////////
// WEBPACK FOOTER
// ./public/assets/ketomau.png
// module id = 1496
// module chunks = 19843951674672